import React, {Component} from 'react';
import LoadingButton from "../../../shared/ui/LoadingButton";
import './UploadFTOGuideliness.scss';
import {Storage} from "../../../shared/services/aws";
import {connect} from "react-redux";
import {FormGroup, Input} from "reactstrap";
import departmentSettingsSelectors from "../../store/department-settings/selectors";

class UploadFTOGuidelines extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      ftoGuidelinesLabel: this.props.settings.ftoGuidelinesLabel || '',
      ftoGuidelines: this.props.settings.ftoGuidelines || null,
      ftoGuidelinesLink: null
    };

    if(this.state.ftoGuidelines) {
      this.getS3Link()
    }
  }

  inputFile;

  updateLabel(val) {
    this.setState({
      ftoGuidelinesLabel: val
    })
  }

  getS3Link() {
    Storage.get(`${this.state.ftoGuidelines}`)
      .then(result => {
        this.setState({
          ftoGuidelinesLink: result
        })
      })
      .catch((err) => {
        console.log(err);
      });
  }

  triggerUpload() {
    this.inputFile.click();
  }

  updateSettings() {
    this.props.onUpdateSettings({
      ftoGuidelines: this.state.ftoGuidelines,
      ftoGuidelinesLabel: this.state.ftoGuidelinesLabel
    })
  }

  uploadFile(event) {
    const file = event.target.files[0];
    const s3Key = `${this.props.userContext.departmentGuid}/department/guidelines/${file.name}`;

    this.setState({
      isLoading: true
    });

    Storage.put(s3Key, file, {contentType: file.type})
      .then((result) => {
        this.setState({
          isLoading: false
        });

        this.setState({
          ftoGuidelines: result.key
        });

        this.getS3Link();
      })
      .catch((error) => {
        this.setState({
          isLoading: false
        });
        console.log(`[AttachmentForm] uploadFile() error: ${JSON.stringify(error)}`);
      });
  }

  render() {
    return (
      <div className="upload-fto-guidelines">
        <input type="file" ref={(ref) => this.inputFile = ref} onChange={e => this.uploadFile(e)}/>
        { this.state.ftoGuidelines && (
          <a className="button secondary" target="_blank" href={this.state.ftoGuidelinesLink}>
            <i className="fa fa-download" />
            <span>Download</span>
          </a>
        )}
        <LoadingButton
          primary
          icon="fa fa-upload"
          text={this.state.ftoGuidelines ? `Upload other ${this.props.ftoShortLabel} guidelines` : `Upload ${this.props.ftoShortLabel} guidelines`}
          isLoading={this.state.isLoading}
          onClick={() => this.triggerUpload()}
        />
        <div className="form form-inline blank-form">
          <FormGroup style={{flex: 1}}>
            <Input
              type="text"
              placeholder={`${this.props.ftoShortLabel} guidelines label`}
              value={this.state.ftoGuidelinesLabel}
              onChange={(e) => this.updateLabel(e.target.value)}/>
          </FormGroup>
        </div>
        <div>
          <button
            className="button primary small"
            disabled={!this.state.ftoGuidelines}
            onClick={() => this.updateSettings()}>
            <i className="fa fa-save" />
            <span>Save</span>
          </button>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  userContext: state.common.userContext,
  ftoShortLabel: departmentSettingsSelectors.ftoShortLabel(state),
});

export default connect(mapStateToProps)(UploadFTOGuidelines)
